import { render, staticRenderFns } from "./AreaCompView.vue?vue&type=template&id=16c4f065&scoped=true"
import script from "./AreaCompView.vue?vue&type=script&lang=js"
export * from "./AreaCompView.vue?vue&type=script&lang=js"
import style0 from "./AreaCompView.vue?vue&type=style&index=0&id=16c4f065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c4f065",
  null
  
)

export default component.exports